export default __webpack_public_path__ + "static/media/IshTakkar_Resume_Fall_2022_3.dec77bc8.pdf";